// src/pages/Privacy/Privacy.jsx
//
// ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ (черновик).
//
// ⚠️ ЧЕРНОВИК. Владелец: «Юридические тексты напиши пробные сам, я потом
//    сам их исправлю». Требует проверки юристом и заполнения реквизитов.
//
// 🔴 ЧТО ЗДЕСЬ ПРИНЦИПИАЛЬНО, А НЕ «ВОДА»:
//    1. Ст. 9 ч. 1 152-ФЗ: оператор ОБЯЗАН ДОКАЗАТЬ наличие согласия.
//       Поэтому согласие фиксируется в БД (дата, версия текста, IP),
//       а не только галочкой в браузере. См. NORRAN_INTEGRATION.txt.
//    2. Согласие на рекламную рассылку — ОТДЕЛЬНОЕ (ст. 15 152-ФЗ).
//       Нельзя прятать его в общее согласие.
//    3. Согласие нельзя предустанавливать — галочка по умолчанию пустая.
//    4. Отзыв согласия — это `revoked_at` в БД, а не удаление записи:
//       удалив строку, мы потеряли бы доказательство, что согласие БЫЛО.
import React from 'react';
import {
  LegalPage,
  LegalSection,
  LegalList,
} from '../../components/common/LegalPage/LegalPage.jsx';
import { REQUISITES, REQUISITES_ADDRESS } from '../../utils/requisites.js';

export const Privacy = () => (
  <LegalPage
    title="Политика обработки персональных данных"
    intro="Настоящая Политика определяет порядок обработки персональных данных и меры по обеспечению их безопасности, применяемые оператором при использовании сайта рекламного агентства «Студия Рекламы»."
  >
    <LegalSection number="1" title="Общие положения">
      <p>
        1.1. Настоящая Политика составлена в соответствии с требованиями
        Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных»
        (далее — Закон о персональных данных) и определяет порядок обработки
        персональных данных и меры по обеспечению безопасности персональных
        данных, предпринимаемые оператором.
      </p>
      <p>
        1.2. Оператор: {REQUISITES.legalName}, ИНН {REQUISITES.inn},
        ОГРНИП {REQUISITES.ogrnip}, адрес: {REQUISITES_ADDRESS}.
      </p>
      <p>
        1.3. Оператор ставит важнейшей целью и условием осуществления своей
        деятельности соблюдение прав и свобод человека и гражданина при
        обработке его персональных данных, в том числе защиты прав на
        неприкосновенность частной жизни, личную и семейную тайну.
      </p>
      <p>
        1.4. Настоящая Политика применяется ко всей информации, которую
        оператор может получить о посетителях сайта{' '}
        {REQUISITES.siteUrl}.
      </p>
    </LegalSection>

    <LegalSection number="2" title="Основные понятия">
      <LegalList
        items={[
          'Персональные данные — любая информация, относящаяся к прямо или косвенно определённому или определяемому физическому лицу (субъекту персональных данных).',
          'Обработка персональных данных — любое действие (операция) или совокупность действий, совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу, обезличивание, блокирование, удаление, уничтожение.',
          'Оператор — юридическое лицо или индивидуальный предприниматель, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных.',
          'Пользователь — посетитель сайта, субъект персональных данных.',
          'Согласие субъекта — конкретное, предметное, информированное и сознательное согласие на обработку его персональных данных.',
        ]}
      />
    </LegalSection>

    <LegalSection number="3" title="Какие данные мы обрабатываем">
      <p>3.1. Оператор может обрабатывать следующие персональные данные:</p>
      <LegalList
        items={[
          'фамилия, имя, отчество (при указании);',
          'адрес электронной почты;',
          'номер контактного телефона;',
          'адрес доставки;',
          'сведения о заказах и истории взаимодействия;',
          'технические данные: IP-адрес, данные cookie, сведения о браузере и устройстве.',
        ]}
      />
      <p>
        3.2. Специальные категории персональных данных (раса, национальность,
        политические взгляды, состояние здоровья, интимная жизнь) оператором{' '}
        <strong>не обрабатываются</strong>.
      </p>
      <p>
        3.3. Обработка биометрических персональных данных оператором{' '}
        <strong>не осуществляется</strong>.
      </p>
    </LegalSection>

    <LegalSection number="4" title="Цели обработки">
      <p>4.1. Персональные данные обрабатываются в следующих целях:</p>
      <LegalList
        items={[
          'оформление, обработка и исполнение заказов, включая доставку;',
          'заключение и исполнение договоров;',
          'информирование о статусе заказа;',
          'обратная связь, ответы на обращения и обращения в поддержку;',
          'улучшение работы сайта и качества обслуживания;',
          'исполнение требований законодательства Российской Федерации.',
        ]}
      />
      <p>
        4.2. Оператор обрабатывает персональные данные только для достижения
        целей, указанных в настоящем разделе. Обработка для целей, не
        совместимых с указанными, не производится.
      </p>
    </LegalSection>

    <LegalSection number="5" title="Правовые основания обработки">
      <p>5.1. Правовыми основаниями обработки являются:</p>
      <LegalList
        items={[
          'Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных»;',
          'согласие субъекта персональных данных на обработку его персональных данных;',
          'необходимость исполнения договора, стороной которого является субъект персональных данных.',
        ]}
      />
      <p>
        5.2. Согласие даётся субъектом персональных данных свободно, своей
        волей и в своём интересе. Формы на сайте содержат{' '}
        <strong>непредустановленную</strong> отметку о согласии: согласие не
        считается полученным, пока пользователь самостоятельно не отметит
        соответствующий пункт.
      </p>
    </LegalSection>

    <LegalSection number="6" title="Порядок и условия обработки">
      <p>
        6.1. Обработка персональных данных осуществляется с согласия субъекта
        персональных данных, а также в случаях, предусмотренных
        законодательством Российской Федерации.
      </p>
      <p>
        6.2. Факт получения согласия фиксируется оператором. В момент
        подтверждения согласия в информационной системе оператора
        сохраняются: вид согласия, версия редакции документа, дата и время
        подтверждения, IP-адрес и сведения о браузере пользователя.
      </p>
      <p>
        6.3. Оператор принимает необходимые правовые, организационные и
        технические меры для защиты персональных данных от неправомерного или
        случайного доступа, уничтожения, изменения, блокирования,
        копирования, предоставления, распространения.
      </p>
      <p>6.4. Персональные данные не передаются третьим лицам, за исключением:</p>
      <LegalList
        items={[
          'случаев, прямо предусмотренных законодательством Российской Федерации;',
          'служб доставки — в объёме, необходимом для доставки заказа;',
          'платёжных организаций — в объёме, необходимом для проведения платежа;',
          'случаев, когда субъект персональных данных дал на это отдельное согласие.',
        ]}
      />
    </LegalSection>

    <LegalSection number="7" title="Сроки обработки и хранения">
      <p>
        7.1. Обработка персональных данных прекращается по достижении целей
        обработки, при отзыве согласия субъектом персональных данных, а также
        при выявлении неправомерной обработки.
      </p>
      <p>
        7.2. Записи о факте получения согласия хранятся в течение срока,
        необходимого для подтверждения законности обработки, в том числе
        после отзыва согласия. Это соответствует требованию части 1 статьи 9
        Закона о персональных данных, согласно которому оператор обязан
        доказать наличие согласия.
      </p>
      <p>
        7.3. При отзыве согласия запись о нём не удаляется, а помечается как
        отозванная с указанием даты отзыва.
      </p>
    </LegalSection>

    <LegalSection number="8" title="Права субъекта персональных данных">
      <p>8.1. Субъект персональных данных имеет право:</p>
      <LegalList
        items={[
          'получать информацию, касающуюся обработки его персональных данных;',
          'требовать уточнения, блокирования или уничтожения своих персональных данных, если они являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;',
          'отозвать согласие на обработку персональных данных;',
          'обжаловать действия или бездействие оператора в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке.',
        ]}
      />
      <p>
        8.2. Для реализации своих прав субъект может направить обращение на
        адрес электронной почты {REQUISITES.email}.
      </p>
    </LegalSection>

    <LegalSection number="9" title="Файлы cookie и аналогичные технологии">
      <p>
        9.1. Сайт может использовать файлы cookie и аналогичные технологии
        для обеспечения работы сайта и анализа поведения посетителей.
      </p>
      <p>
        9.2. Необходимые файлы cookie обеспечивают базовую работу сайта
        (авторизация, сохранение корзины) и используются на основании
        законного интереса оператора. Отключение таких файлов может привести
        к неработоспособности отдельных функций сайта.
      </p>
      <p>
        9.3. Необязательные файлы cookie (аналитические, маркетинговые)
        используются исключительно после получения согласия пользователя.
        Согласие может быть отозвано в любой момент.
      </p>
      <p>
        9.4. Пользователь может отключить файлы cookie в настройках своего
        браузера. Порядок отключения определяется документацией
        соответствующего браузера.
      </p>
    </LegalSection>

    <LegalSection number="10" title="Заключительные положения">
      <p>
        10.1. Оператор вправе вносить изменения в настоящую Политику. Новая
        редакция вступает в силу с момента её размещения на сайте, если иное
        не предусмотрено новой редакцией.
      </p>
      <p>
        10.2. При внесении существенных изменений оператор указывает новую
        версию редакции. Согласие, полученное на предыдущую редакцию,
        сохраняется с указанием версии, на которую оно было дано.
      </p>
      <p>
        10.3. Действующая редакция: версия 1.0. Актуальный текст постоянно
        доступен по адресу {REQUISITES.siteUrl}/privacy.
      </p>
    </LegalSection>
  </LegalPage>
);
